module.exports = __webpack_public_path__ + "img/activities-23.e14d2c9b.jpg";